<template>
    <div>
        <section class="content-header">
      <h1>
        <span>Uygulama Ayarları</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>Kontrol Paneli</span>
        </li>
        <li>
          <span>Ayarlar</span>
        </li>
        <li>
          <span>Uygulama Ayarları</span>
        </li>
      </ol>
    </section>
    <section class="content">
    </section>
    </div>
</template>
<script>
export default {
    
}
</script>


// WEBPACK FOOTER //
// src/pages/AppSettings/AppSettings.vue